import { selectorFamily, useRecoilValue } from 'recoil';
import { convertPaymentDetails, dateRangeToDates } from 'functions';
import { DeductionService } from 'services';
import { currentDate, isAuthenticated, refreshState, useSetRefreshState } from 'state';
import { PaymentDetail } from 'types';
import { DateRangeType } from 'enums';

type DeductionParams = {
    accountId: string,
    customerId?: string,
    dateRange: DateRangeType,
};

export const deductions = selectorFamily<PaymentDetail[], DeductionParams>({
    key: 'deductions',
    get: ({ accountId, customerId, dateRange }) =>
        async ({ get }) => {
            get(currentDate);
            get(refreshState(deductions({ accountId, customerId, dateRange }).key))
            if (get(isAuthenticated) && accountId) {
                const service = new DeductionService();
                const { startDate, endDate } = dateRangeToDates(dateRange);
                const data = await service.getDeductionsByDate(accountId, startDate, endDate, customerId);
                return convertPaymentDetails(data);
            }
            return [];
        }
});

export const useDeductions = (accountId: string, dateRange: DateRangeType = DateRangeType.OneYear) =>
    useRecoilValue(deductions({ accountId, dateRange }));

export const useRefreshDeductions = (accountId: string, dateRange: DateRangeType = DateRangeType.OneYear) =>
    useSetRefreshState(deductions({ accountId, dateRange }));
